/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationFormStatus,
  PagedDocumentDto,
  ProblemDetails,
} from '../models/index';
import {
    ApplicationFormStatusFromJSON,
    ApplicationFormStatusToJSON,
    PagedDocumentDtoFromJSON,
    PagedDocumentDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface GetDocumentsRequest {
    organizationId: string;
    page?: number;
    size?: number;
    sortBy?: GetDocumentsSortByEnum;
    sortDirection?: GetDocumentsSortDirectionEnum;
    search?: string;
    status?: Array<ApplicationFormStatus>;
}

/**
 * 
 */
export class DocumentApi extends runtime.BaseAPI {

    /**
     * Get paginated document list (latest version per application form matching filters)
     */
    async getDocumentsRaw(requestParameters: GetDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedDocumentDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getDocuments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sortDirection'] = requestParameters['sortDirection'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/documents`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedDocumentDtoFromJSON(jsonValue));
    }

    /**
     * Get paginated document list (latest version per application form matching filters)
     */
    async getDocuments(requestParameters: GetDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedDocumentDto> {
        const response = await this.getDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetDocumentsSortByEnum = {
    Name: 'name',
    Status: 'status',
    CreatedAt: 'createdAt'
} as const;
export type GetDocumentsSortByEnum = typeof GetDocumentsSortByEnum[keyof typeof GetDocumentsSortByEnum];
/**
 * @export
 */
export const GetDocumentsSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetDocumentsSortDirectionEnum = typeof GetDocumentsSortDirectionEnum[keyof typeof GetDocumentsSortDirectionEnum];
